// Single source of truth for currency formatting (CAD). Returns an em dash for
// nullish values so callers don't each re-implement the guard.
export const formatMoney = (value?: number | null): string =>
  value == null
    ? "—"
    : value.toLocaleString("en-CA", { style: "currency", currency: "CAD" });
